import { render, staticRenderFns } from "./ModalFormRegistration.vue?vue&type=template&id=a7df4610&scoped=true&"
import script from "./ModalFormRegistration.vue?vue&type=script&lang=js&"
export * from "./ModalFormRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7df4610",
  null
  
)

export default component.exports